'use client';
import React, { forwardRef, ReactNode, MouseEvent } from 'react';
import { LinkProps as NextLinkProps } from 'next/link';
import { Link, useRouter } from '../../utils/routing';
import { Link as MuiLink } from '@mui/material';

type Props = NextLinkProps & { prefetch?: boolean; children?: ReactNode };

const LinkBehaviour = forwardRef<HTMLAnchorElement, Props>(
  function LinkBehaviour(props, ref) {
    const router = useRouter();
    let href = props.href.toString();
    const isExternalLink = href.startsWith('http');
    const isModal = href.startsWith('/modal/');
    const modalHref = href;
    href = isModal ? href.replace('/modal', '') : href;
    const onClick = (e?: MouseEvent<HTMLAnchorElement>) => {
      if (isModal) {
        e?.preventDefault();

        router.push(modalHref, { scroll: false });
      }
      props.onClick?.(e as any);
    };
    if (isExternalLink) {
      return (
        <MuiLink
          component={'a'}
          sx={{
            color: 'inherit',
            textDecoration: 'hover',
            fontSize: 'inherit',
          }}
          {...props}
          href={href}
          rel={'noopener noreferrer'}
        >
          {props.children}
        </MuiLink>
      );
    }
    return (
      <Link
        ref={ref}
        {...props}
        href={href}
        onClick={onClick}
        locale={props.locale ? `${props.locale}` : undefined}
      />
    );
  },
);

export default LinkBehaviour;
